// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1xJV9","messages":"Chat_messages__25Tf7","dateDivider":"Chat_dateDivider__TvLHj"};